export const LEDGER_DETAIL_TYPE = {
  Payment: "payment",
  Adjustment: "adjustment",
  /** Derived, not posted: the parent's remainder moving to the statement that re-bills it. */
  TransferOut: "transfer-out",
  /** Derived, not posted: a cancelled sub-statement's balance coming back to its parent. */
  BalanceReturn: "balance-return",
  /** Derived, not posted: a cancelled sub-statement's balance leaving for its parent. */
  BalanceReturnOut: "balance-return-out",
} as const;

export type LedgerDetailType = (typeof LEDGER_DETAIL_TYPE)[keyof typeof LEDGER_DETAIL_TYPE];
